import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Avatar, CircularProgress, Dialog, DialogContent, Divider, Menu, MenuItem, Typography, useMediaQuery, useTheme } from '@mui/material';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CommonDialog from '../../common/CommonDialog';
import { imageUrl } from '../../config/dataService/dataService';
import { shopDetails } from '../../redux/Account/ShopDetails/action';
import { handlelogout } from '../../redux/Auth/action';
import useGlobalStore from '../../store/useGlobalStore';
import ServiceModal from './SendFeedbackModal';

function ShopPopup(props) {
    const navigate = useNavigate();
    const { isDirty, resetGlobalState, isSettingsDirty, resetSettingsDirty } = useGlobalStore();
    const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
    const location = useLocation();
    const discardModalTitle = location.pathname.split('/').includes('record-payment')
        ? 'Record Payment'
        : location.pathname.split('/').includes('invoice')
          ? 'invoice'
          : location.pathname.split('/').includes('estimates')
            ? 'estimate'
            : location.pathname.split('/').includes('work-orders')
              ? 'work order'
              : 'invoice';

    const discardModalDescription = location.pathname.split('/').includes('record-payment')
        ? 'You have unsaved changes. Do you want to discard the recorded payments or continue editing?'
        : location.pathname.split('/').includes('invoice') || location.pathname.split('/').includes('estimate')
          ? `You have unsaved changes. Do you want to discard this ${discardModalTitle} or continue editing?`
          : `You have unsaved changes. Do you want to discard this ${discardModalTitle} or continue editing?`;

    const [discardModalOpen, setDiscardModalOpen] = React.useState(false);
    const [pendingNavigation, setPendingNavigation] = React.useState(null);
    const [pendingAction, setPendingAction] = React.useState(null); // New state for pending actions

    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [image, setImage] = useState(JSON.parse(localStorage.getItem('apex-saas_details'))?.images?.find((d) => d.type == 'primary'));

    const logout = async () => {
        setShowLoader(true);
        const resp = await dispatch(handlelogout());

        if (resp) {
            window.location.replace(`${process.env.PUBLIC_URL}/`);
        }
        setShowLoader(false);
    };

    const [name, setName] = useState(JSON.parse(localStorage.getItem('apex-saas_details'))?.shopName?.split(' '));
    const [shopDetailss, setShopDetails] = useState(JSON.parse(localStorage.getItem('apex-saas_details')));

    useEffect(() => {
        const handleStorageChange = (event) => {
            setImage(JSON.parse(localStorage.getItem('apex-saas_details'))?.images?.find((d) => d.type == 'primary'));
        };

        window.addEventListener('localStorageChange', handleStorageChange);

        return () => {
            window.removeEventListener('localStorageChange', handleStorageChange);
        };
    }, []);

    useEffect(() => {
        getShopDetails();

        const handleStorageChange = (event) => {
            setShopDetails(JSON.parse(localStorage.getItem('apex-saas_details')));
        };

        window.addEventListener('localStorageChangeShopName', handleStorageChange);

        return () => {
            window.removeEventListener('localStorageChangeShopName', handleStorageChange);
        };
    }, []);

    const getShopDetails = async () => {
        setShowLoader(true);
        const data = await dispatch(shopDetails());
        if (data) {
            setShowLoader(false);
        }
    };

    const BasicDetails = useSelector((state) => state?.account?.shopDetailsData);

    // Function to handle navigation with dirty check
    const handleNavigation = (path) => {
        if (isDirty || isSettingsDirty) {
            setPendingNavigation(path);
            setPendingAction('navigate');
            setDiscardModalOpen(true);
        } else {
            navigate(path);
            localStorage.removeItem('searchValue');
        }
    };

    // Function to handle logout with dirty check
    const handleLogoutClick = () => {
        if (isDirty || isSettingsDirty) {
            setPendingAction('logout');
            setDiscardModalOpen(true);
        } else {
            logout();
        }
    };

    // Function to handle feedback modal with dirty check
    const handleFeedbackClick = () => {
        if (isDirty || isSettingsDirty) {
            setPendingAction('feedback');
            setDiscardModalOpen(true);
        } else {
            setOpenFeedbackModal(true);
        }
    };

    // Handle discard confirmation
    const handleDiscardConfirm = () => {
        resetGlobalState();
        resetSettingsDirty();
        setDiscardModalOpen(false);

        // Execute the pending action
        if (pendingAction === 'navigate' && pendingNavigation) {
            navigate(pendingNavigation);
            localStorage.removeItem('searchValue');
            setPendingNavigation(null);
        } else if (pendingAction === 'logout') {
            logout();
        } else if (pendingAction === 'feedback') {
            setOpenFeedbackModal(true);
        }

        setPendingAction(null);
    };

    // Handle discard cancel
    const handleDiscardCancel = () => {
        setDiscardModalOpen(false);
        setPendingNavigation(null);
        setPendingAction(null);
    };

    return (
        <>
            <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                    <div
                        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                        //   {...bindTrigger(popupState)}
                    >
                        <div {...bindTrigger(popupState)}>
                            <Avatar
                                alt="Avatar"
                                variant="circular"
                                sx={{
                                    marginRight: '15px',
                                    height: '48px',
                                    width: '48px',
                                    borderRadius: '4px',
                                    background: image?.url ? 'white' : '#002394',
                                }}
                                src={imageUrl + image?.url}
                            >
                                {name?.[0]?.[0] + name?.[1]?.[0]}
                            </Avatar>
                        </div>
                        <div {...bindTrigger(popupState)}>
                            <Typography
                                variant="contained"
                                // {...bindTrigger(popupState)}
                            >
                                {/* {getItem("apex-saas_details")?.shopName
                  ? getItem("apex-saas_details")?.shopName
                  : "Auto Repair Shop Name"} */}
                                <ExpandMoreIcon style={{ color: 'rgba(142, 142, 142, 1)' }} />
                            </Typography>
                        </div>
                        <Menu {...bindMenu(popupState)} sx={{ mt: '20px', minWidth: '256px' }}>
                            <MenuItem style={{ background: 'white' }}>
                                <Avatar
                                    alt="Avatar"
                                    variant="circular"
                                    sx={{
                                        marginRight: '15px',
                                        height: '48px',
                                        width: '48px',
                                        borderRadius: '4px',
                                    }}
                                    src={imageUrl + image?.url}
                                >
                                    {name?.[0]?.[0] + name?.[1]?.[0]}
                                </Avatar>

                                {BasicDetails?.shopName ?? 'Auto Repair Shop Name'}
                                {/* {   getItem("apex-saas_details")?.shopName
                  ? getItem("apex-saas_details")?.shopName
                  : "Auto Repair Shop Name"} */}
                            </MenuItem>
                            <Divider />
                            <MenuItem
                                onClick={() => {
                                    popupState.close();
                                    handleNavigation('/account-settings/personal-information');
                                }}
                            >
                                Account Settings
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    popupState.close();
                                    handleFeedbackClick();
                                }}
                            >
                                Send Feedback
                            </MenuItem>
                            {/* <MenuItem
                                onClick={() => {
                                    popupState.close();
                                    handleNavigation('referrals');
                                }}
                            >
                                Invite Customers
                            </MenuItem> */}
                            <Divider />
                            <MenuItem
                                onClick={() => {
                                    popupState.close();
                                }}
                            >
                                <Link
                                    to={'https://apexmechanic.com/privacy-policy/'}
                                    target="_blank"
                                    style={{ textDecoration: 'none', color: 'rgba(0,0,0,0.87)' }}
                                >
                                    Privacy Policy and Terms
                                </Link>
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    popupState.close();
                                    handleLogoutClick();
                                }}
                            >
                                Sign Out
                            </MenuItem>
                        </Menu>
                    </div>
                )}
            </PopupState>
            <Dialog fullScreen={false} open={showLoader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
            <ServiceModal open={openFeedbackModal} handleClose={() => setOpenFeedbackModal(false)} />

            {/* ✅ Unsaved Changes Modal */}
            <CommonDialog
                open={discardModalOpen}
                onClose={handleDiscardCancel}
                onSave={handleDiscardConfirm}
                dialogTitle={
                    discardModalTitle
                        ? `Discard ${discardModalTitle.replace(/\b\w/g, (c) => c.toUpperCase())}${location.pathname.split('/').includes('record-payment') ? '' : '?'}`
                        : 'Discard?'
                }
                dialogSubtitle={discardModalDescription}
                saveButtonText={'Discard'}
            />
        </>
    );
}

export default ShopPopup;
